<script setup lang="ts">
    import type { IntroData, VideoWidgetData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    const props = defineProps<IWidgetProps<VideoWidgetData>>();
    const appStore = useAppStore();
    const { data, getValueSequence } = useWidget(props);

    const videos = computed(() => {
        return data.value ? getValueSequence(data.value) : [];
    });

    const intro = computed(() => {
        if (!data.intro) return;
        return {
            title: data.intro.title,
            subtitle: textLinks(data.intro.subtitle, appStore.getReference),
            icon: data.intro.icon,
        } as IntroData;
    });
</script>
<template>
    <org-video-slider
        class="cms-video-widget-container"
        :background="data.style?.background_color"
        :intro="intro"
        :videos="videos" />
</template>
